export default function getReleaseNotes() {
    return [
        {
            version: "2.6.19",
            titleFeatures: "Nouvelles fonctionnalités",
            features: [
                {
                    title: "File d'attente dynamique",
                    notes: `
                    <div>
                            <p>Pour gérer les flux d'appels simultanés, SkaLink gère dynamiquement les files d'attente, par Centre d'appel.</p>
                            <h3>Côté Agent</h3>
                            <ul>
                                <li>Intercom : l'agent a la possibilité de placer un utilisateur en file d'attente et de le reprendre à tout moment.</li>
                                <li>Pilot : ajout d'une nouvelle entrée 'File d'attente' dans le menu latéral.</li>
                                <li>Pilot / Dashboard : ajout d'une statistique sur l'évolution des files d'attente. Affichage en temps réel ou sur une période donnée.</li>
                            </ul>
                            <h3>Côté utilisateur</h3>
                            <ul>
                                <li>Affichage de la position dans la file d'attente et du temps d'attente estimé. Données mises à jour en temps réel.</li>
                            </ul>
                        </div>
                    `
                },
                {
                    title: "Liens d'appel",
                    notes: `
                        <div>
                            <p>SkaLink permet dorénavant de générer des liens d'appel dynamiques, permettant à vos utilisateurs de vous contacter en vidéo depuis leur PC ou mobile.</p>
                            <h3>Côté Agent</h3>
                            <ul>
                                <li>Ajout d'une nouvelle entrée 'Liens d'appel' dans le menu latéral.</li>
                                <li>Génération de liens d'appel avec durée de validité et traçabilité de la zone.</li>
                                <li>Formats : QR Code ou lien d'appel à partager (réseaux sociaux, site web, …).</li>
                            </ul>
                            <h3>Côté utilisateur</h3>
                            <ul>
                                <li>Compatible PC et mobile directement depuis le navigateur de l'appareil : aucune app à installer, l'appel se fait via la Webcall SkaLink.</li>
                            </ul>
                        </div>
                    `
                },
                {
                    title: "Mode Absence",
                    notes: `
                        <div>
                            <p>Contrairement au 'mode Pause' existant – pour les pauses brèves – le mode Absence permet aux Agents de signaler une indisponibilité prolongée.</p>
                            <ul>
                                <li>Intercom : distinction entre le 'mode Pause' et le 'mode Absence'. En mode Pause : les appels entrants sont automatiquement placés en file d'attente (ce mode est idéal lorsqu'il s'agit d'une pause très brève). Mode Absence : voir le point ci-dessous.</li>
                                <li>Redirection automatique : lorsque le 'mode Absence' est enclenché, les appels sont automatiquement redirigés vers un autre Intercom disponible ou vers un autre Centre d'appel, en suivant des règles programmées au préalable (ex : en dehors des horaires d'ouverture).</li>
                            </ul>
                        </div>
                    `
                },
                {
                    title: "Arrière-plan dynamique",
                    notes: `
                        <div>
                            <p>Pour plus de confidentialité ou pour affirmer votre identité de marque, SkaLink permet dorénavant de modifier l'apparence de votre arrière-plan, avec 3 options :</p>
                            <ul>
                                <li>Image de votre choix, définie dans le Pilot.</li>
                                <li>Flou d'arrière-plan.</li>
                                <li>Vidéo normale, sans effet.</li>
                            </ul>
                        </div>
                    `
                }
            ],
            titleBugs: "Améliorations",
            bugs: [
                {
                    title: "Journal des appels",
                    notes: `
                        <div>
                            <p>Ajout de la colonne 'Agent' dans le tableau du journal des appels, ce qui permet d’identifier la personne en charge de chaque appel traité.</p>
                        </div>
                    `
                },
                {
                    title: "UX/UI",
                    notes: `
                        <div>
                            <h3>Optimisations pour les petits écrans</h3>
                            <ul>
                                <li>Menu latéral : réduction de la largeur occupée + possibilité de minimiser le menu latéral, laissant plus de place au contenu.</li>
                                <li>Tableaux : possibilité d'ajustement la largeur des colonnes de tableaux dynamiques : personnalisation pour un meilleur confort d'utilisation.</li>
                            </ul>
                            <h3>Divers</h3>
                            <ul>
                                <li>Possibilité d'ajouter une photo de profil (avatar) depuis le menu latéral.</li>
                            </ul>
                        </div>
                    `
                }
            ]
        }
    ];
}
